import { formatWithTimezone } from "../../common/utils/common";

const dash = (val) => val || "—";

export const customerManagementColumns = (actionCellRenderer) => [
  { title: "First Name",  dataIndex: "firstName",  key: "firstName",  render: dash },
  { title: "Last Name",   dataIndex: "lastName",   key: "lastName",   render: dash },
  { title: "Email",       dataIndex: "email",      key: "email",      render: dash },
  { title: "Contact No.", dataIndex: "mobileNo",   key: "mobileNo",   render: dash },
  { title: "NIC",         dataIndex: "nic",        key: "nic",        render: dash },
  {
    title: "Created On",
    dataIndex: "createdAt",
    key: "createdAt",
    render: (dt) => formatWithTimezone(dt) || "—",
  },
  {
    title: "Updated On",
    dataIndex: "modifiedOn",
    key: "modifiedOn",
    render: (dt) => formatWithTimezone(dt) || "—",
  },
  { title: "Updated By", dataIndex: "modifiedBy", key: "modifiedBy", render: dash },
  {
    title: "Actions",
    dataIndex: "",
    key: "actions",
    render: actionCellRenderer,
    width: 340,
  },
];
